export default {
    "main": "SP Chính",
    "gift": "SP Quà tặng",
    "bag": "SP Bao bì",
}
